import VDMDashboardLubeOils from "components/app/vdmdashboard/lube-oils/VDMDashboardLubeOils";
import React from "react";

type ScreenVDMDashboardLubeOilsType = React.PropsWithChildren<{
	match: {
		params: {
			vesselId: string;
		};
	};
}>;
const ScreenVDMDashboardLubeOils: React.FC<ScreenVDMDashboardLubeOilsType> = (
	props: ScreenVDMDashboardLubeOilsType
) => {
	return <VDMDashboardLubeOils vesselId={props.match.params.vesselId} />;
};

export default ScreenVDMDashboardLubeOils;